import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import request from "../Services/API/Requests";

const initialState = {
    isReadyApp: false,
    isOpenDrawer: false,
    drawerWidth: 0,
    isAuth: false,
    userLanguage: 'en',
    inFocus: 'content',
    clearProps: false,
    updateData: false,
    application: null,
    appLanding: {id: '', children: [{}]},
    drawerProps: {
        closedCompact: false,
    },
    appEnv: window.location.pathname.replace(/^\/([^\/]*)\/([^\/]*).*$/, '$1')
}

const fetchApplication = createAsyncThunk('fetchApp', async id => {
    const application = await request({
        url: 'application/read',
        data: {id}
    });
    const landingRes = await request({
        url: 'screen/read',
        data: {id: application.landingPage}
    })

    return {application: id, landingRes};
})

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setReadyApp: state => {
            state.isReadyApp = true
        },
        toggleDrawer: state => {
            state.isOpenDrawer = !state.isOpenDrawer
        },
        setDrawerState: (state, action) => {
            state.isOpenDrawer = action.payload;
        },
        changeDrawerWidth: (state, action) => {
            state.drawerWidth = action.payload
        },
        setAuth: (state, action) => {
            state.isAuth = action.payload;
        },
        setUserLanguage: (state, action) => {
            localStorage.setItem('language', action.payload);
            state.userLanguage = action.payload;
        },
        setInitialUserLanguage: state => {
            state.userLanguage = localStorage.getItem('language') || 'en'
        },
        setFocus: (state, action) => {
            state.inFocus = action.payload;
        },
        setClearProps: (state, action) => {
            state.clearProps = action.payload;
        },
        setUpdateData: (state, action) => {
            state.updateData = action.payload;
        },
        setAppLanding: (state, action) => {
            state.appLanding = action.payload;
        },
        setApplication: (state, action) => {
            state.application = action.payload;
        },
        setDrawerProps: (state, action) => {
            state.drawerProps = action.payload;
        }
    },
    extraReducers: builder => {
        builder.addCase(fetchApplication.pending, state => {
            state.isReadyApp = false;
        })
        builder.addCase(fetchApplication.fulfilled, (state, action) => {
            state.appLanding = action.payload.landingRes;
            state.isReadyApp = true;
        })
        builder.addCase(fetchApplication.rejected, state => {
            state.appLanding = initialState.appLanding;
            state.isReadyApp = true;
        })
    }
})

export const {
    changeDrawerWidth, toggleDrawer, setDrawerState,
    setAuth, setUserLanguage, setFocus, setClearProps,
    setUpdateData, setReadyApp, setAppLanding, setApplication,
    setInitialUserLanguage, setDrawerProps
} = appSlice.actions;

export {
    fetchApplication
}

export default appSlice.reducer;